/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  serviceId: ZodTypes.Id,
});

export const GetDeepthinkerLatestRuntime = {
  id: 'deepthinker-latest-runtime.get',
  tag: 'Deepthinker',
  summary: 'Get latest deepthinker runtime',
  description: 'Get latest deepthinker runtime of a service',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.serviceId}/deepthinker/latest`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            timestamp: ZodTypes.Timestamp.optional(),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
